module.exports = __webpack_public_path__ + "static/media/maestridellagrandine_logo_OLD.e4866d33.jpg";